import { GrupoImunobiologicoEnum, VacinaAplicadaCidadaoConsolidadoFragment } from 'graphql/types.generated'
import { chain, mapValues } from 'lodash'
import { isUndefinedOrNull } from 'util/checks'
import { HOJE, humanizeDate } from 'util/date/humanize-date'
import { instantToDateString } from 'view/atendimentos/detail/soap/aside/acompanhamento-puericultura/util/convertToLabel'

export function formatVacinasAplicadasCidadaoConsolidadoByGrupoImunobiologico(
  vacinas: VacinaAplicadaCidadaoConsolidadoFragment[]
): Partial<Record<GrupoImunobiologicoEnum, string[]>> {
  return mapValues(GrupoImunobiologicoEnum, (grupo) =>
    chain(vacinas)
      .filter((vacina) => vacina.dimensaoImunobiologico.grupo.includes(grupo))
      .thru(formatVacinasAplicadasCidadaoConsolidado)
      .value()
  )
}

export function formatVacinasAplicadasCidadaoConsolidado(
  vacinas: VacinaAplicadaCidadaoConsolidadoFragment[]
): string[] {
  if (isUndefinedOrNull(vacinas) || vacinas.isEmpty()) {
    return []
  }

  return chain(vacinas)
    .sortBy((vacina) => vacina.dimensaoDoseImunobiologico.ordem)
    .groupBy((vacina) => vacina.dimensaoDoseImunobiologico.sigla)
    .map(concatVacinasDaDoseByDataAplicacao)
    .value()
}

const concatVacinasDaDoseByDataAplicacao = (
  vacinas: VacinaAplicadaCidadaoConsolidadoFragment[],
  dose: string
): string => {
  const imunosFormatados = chain(vacinas)
    .sortBy((vacina) => vacina.dataRegistroVacinaAplicada)
    .map(
      ({ dimensaoImunobiologico: { nome, sigla }, dataRegistroVacinaAplicada }) =>
        `${instantToDateString(dataRegistroVacinaAplicada)} - ${nome} (${sigla})`
    )
    .join(' | ')

  return `${dose} - ${imunosFormatados}`
}

export const humanizedDateAcompanhamentoCondicaoSaude = (
  dataNascimento: LocalDate,
  dataPrimeiraConsulta: LocalDate
) => {
  const humanized = humanizeDate(dataNascimento, dataPrimeiraConsulta)
  return humanized === HOJE ? 'Recém nascido' : humanized
}
